<template>
  <section id="about" class="py-12 about-section bg-grey-darken-2">
    <v-container>
      <v-row align="center">
        <v-col cols="12" md="6">
          <v-img 
            :src="aboutImage" 
            height="500" 
            class="rounded-lg elevation-3"
          ></v-img>
        </v-col>
        <v-col cols="12" md="6">
          <h2 class="text-h3 font-weight-bold mb-4">ABOUT ME</h2>
          <p class="text-h6 font-weight-light mb-4">
            Hi, I'm Alex Morgan, a professional photographer with over 10 years of experience capturing special moments.
          </p>
          <p class="mb-4">
            My passion is to tell stories through my lens, creating timeless images that reflect the beauty and emotion of every moment. 
            I specialize in portrait, wedding, and commercial photography.
          </p>
          <v-chip-group>
            <v-chip 
              v-for="skill in skills" 
              :key="skill" 
              color="primary"
              class="ma-1"
            >
              {{ skill }}
            </v-chip>
          </v-chip-group>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'AboutComponent',
  data() {
    return {
      aboutImage: 'https://images.unsplash.com/photo-1554048612-b6a482bc67e5?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
      skills: [
        'Portrait Photography',
        'Wedding Photography',
        'Commercial Photography',
        'Photo Editing',
        'Lighting',
        'Studio Photography'
      ]
    };
  }
});
</script>

<style scoped>
.about-section {
  scroll-margin-top: 64px;
}

@media (max-width: 960px) {
  .about-section {
    scroll-margin-top: 56px;
  }
}
</style>